import "core-js/modules/es.array.index-of";
import { deepExtract } from 'helpers/deep';
export var isLoggedIn = function isLoggedIn(state) {
  return !!state.user.loggedIn;
};
export var memberStatus = function memberStatus(state) {
  return state.user.loggedIn && state.entities.userProfile.data.default ? state.entities.userProfile.data.default.membership.status : '';
};
export var userHasCpCorporateEmail = function userHasCpCorporateEmail(state) {
  return deepExtract('default.email', state.entities.userProfile.data, '').indexOf('@classpass.com') !== -1;
};
export var userId = function userId(state) {
  return state.user.loggedIn && state.entities.userProfile.data.default ? state.entities.userProfile.data.default.id : null;
};
export var viewingNextCycle = function viewingNextCycle(state) {
  return state.user.viewingNextCycle;
};
export var scheduleContext = function scheduleContext(state) {
  return state.user.scheduleContext;
};